import React from "react";
import { useLocation } from "react-router-dom";
import { MessageCircle, X } from "lucide-react";
import { CS_TEAM } from "@/data/contact";

const WA_TEXT = "Assalamualaikum, saya ingin bertanya tentang paket umrah & haji BATIK Travel Bekasi.";

export default function FloatingWA() {
  const { pathname } = useLocation();
  const [open, setOpen] = React.useState(false);
  const [idx] = React.useState(() => Math.floor(Math.random() * CS_TEAM.length)); // rotate primary CS on load
  const hidden = pathname.startsWith("/admin") || pathname.startsWith("/login");

  // Close on ESC — must be declared before any early return
  React.useEffect(() => {
    if (!open) return;
    const onKey = (e) => e.key === "Escape" && setOpen(false);
    window.addEventListener("keydown", onKey);
    return () => window.removeEventListener("keydown", onKey);
  }, [open]);

  if (hidden) return null;

  return (
    <div className="fixed bottom-6 right-6 z-40" data-testid="floating-wa-container">
      {open && (
        <div
          className="absolute bottom-16 right-0 mb-1 bg-white rounded-2xl shadow-2xl border border-border w-72 overflow-hidden animate-in fade-in slide-in-from-bottom-2 duration-200"
          data-testid="floating-wa-popover"
        >
          <div className="bg-[#075E54] text-white px-4 py-3 flex items-center justify-between">
            <div>
              <p className="text-sm font-semibold">Chat CS BATIK Travel</p>
              <p className="text-xs opacity-80">Pilih customer service tersedia</p>
            </div>
            <button
              onClick={() => setOpen(false)}
              aria-label="Close"
              className="p-1 rounded-full hover:bg-white/10"
              data-testid="floating-wa-close"
            >
              <X className="h-4 w-4" />
            </button>
          </div>
          <div className="p-2">
            {CS_TEAM.map((cs) => (
              <a
                key={cs.number}
                href={`https://wa.me/${cs.number}?text=${encodeURIComponent(WA_TEXT)}`}
                target="_blank"
                rel="noopener noreferrer"
                data-testid={`floating-wa-cs-${cs.name.toLowerCase()}`}
                className="flex items-center gap-3 px-3 py-2.5 rounded-lg hover:bg-muted transition-colors"
                onClick={() => setOpen(false)}
              >
                <div className="h-9 w-9 rounded-full bg-[#25D366] text-white grid place-items-center shrink-0 font-semibold">
                  {cs.name.charAt(0)}
                </div>
                <div className="min-w-0 flex-1">
                  <p className="font-medium text-primary text-sm">{cs.name}</p>
                  <p className="text-[11px] text-muted-foreground">{cs.display}</p>
                </div>
                <span className="text-[10px] font-semibold uppercase tracking-wider text-emerald-600">Chat</span>
              </a>
            ))}
          </div>
          <p className="text-[10px] text-center text-muted-foreground pb-3 px-4">
            Jam operasional: Senin–Jumat 09:00–17:00 · Sabtu 09:00–14:45 WIB
          </p>
        </div>
      )}

      <button
        onClick={() => setOpen((v) => !v)}
        aria-label="Chat on WhatsApp"
        data-testid="floating-wa-btn"
        className="group flex items-center gap-3 bg-[#25D366] text-white rounded-full shadow-2xl pl-4 pr-5 py-3 hover:scale-105 transition-all duration-300"
      >
        <span className="relative flex h-3 w-3">
          <span className="absolute inline-flex h-full w-full rounded-full bg-white/70 opacity-75 animate-ping" />
          <span className="relative inline-flex rounded-full h-3 w-3 bg-white" />
        </span>
        <MessageCircle className="h-5 w-5" />
        <span className="hidden sm:inline text-sm font-medium">Chat WhatsApp</span>
      </button>
    </div>
  );
}
